import type { ComponentType } from 'react';
import type { ClassNameProp } from '@utils';
import Adventure from './adventure';
import Badminton from './badminton';
import Baseball from './baseball';
import Basketball from './basketball';
import Birthday from './birthday';
import Blitzball from './blitzball';
import Bocceball from './bocceball';
import Bowling from './bowling';
import Boxing from './boxing';
import Broomball from './broomball';
import Catchball from './catchball';
import Cheer from './cheer';
import Cornhole from './cornhole';
import CorporateEvents from './corporateevents';
import Cricket from './cricket';
import Crossfit from './crossfit';
import Curling from './curling';
import Cycling from './cycling';
import Dance from './dance';
import Dodgeball from './dodgeball';
import FieldHockey from './fieldhockey';
import FigureSkating from './figure_skating';
import Fitness from './fitness';
import Football from './football';
import Frisbee from './frisbee';
import Futsal from './futsal';
import Golf from './golf';
import Gymnastics from './gymnastics';
import Handball from './handball';
import Hockey from './hockey';
import Kickball from './kickball';
import Kickboxing from './kickboxing';
import Lacrosse from './lacrosse';
import MartialArts from './martialarts';
import NinjaParkour from './ninja_parkour';
import Other from './other';
import Outdoor from './outdoor';
import Pickleball from './pickleball';
import Pilatis from './pilatis';
import Pingpong from './pingpong';
import Raquetball from './raquetball';
import Rollerderby from './rollerderby';
import Rowing from './rowing';
import Rugby from './rugby';
import Running from './running';
import Sailing from './sailing';
import Skating from './skating';
import Skeeball from './skeeball';
import Skiing from './skiing';
import Snowboarding from './snowboarding';
import Soccer from './soccer';
import Softball from './softball';
import Spinning from './spinning';
import Squash from './squash';
import Sup from './sup';
import Surfing from './surfing';
import Swiming from './swiming';
import Tennis from './tennis';
import ThrowingAxe from './throwingaxe';
import Triathlon from './triathlon';
import Vollyball from './vollyball';
import Wiffleball from './wiffleball';
import WindSurfing from './windsurfing';
import Yoga from './yoga';

export {
	Adventure,
	Badminton,
	Baseball,
	Basketball,
	Birthday,
	Blitzball,
	Bocceball,
	Bowling,
	Boxing,
	Broomball,
	Catchball,
	Cheer,
	Cornhole,
	CorporateEvents,
	Cricket,
	Crossfit,
	Curling,
	Cycling,
	Dance,
	Dodgeball,
	FieldHockey,
	FigureSkating,
	Fitness,
	Football,
	Frisbee,
	Futsal,
	Golf,
	Gymnastics,
	Handball,
	Hockey,
	Kickball,
	Kickboxing,
	Lacrosse,
	MartialArts,
	NinjaParkour,
	Other,
	Outdoor,
	Pickleball,
	Pilatis,
	Pingpong,
	Raquetball,
	Rollerderby,
	Rowing,
	Rugby,
	Running,
	Sailing,
	Skating,
	Skeeball,
	Skiing,
	Snowboarding,
	Soccer,
	Softball,
	Spinning,
	Squash,
	Sup,
	Surfing,
	Swiming,
	Tennis,
	ThrowingAxe,
	Triathlon,
	Vollyball,
	Wiffleball,
	WindSurfing,
	Yoga,
};

const sportIconByCanonicalKey: Record<string, ComponentType<ClassNameProp>> = {
	s_adventure: Adventure,
	s_badminton: Badminton,
	s_baseball: Baseball,
	s_basketball: Basketball,
	s_birthday: Birthday,
	s_blitzball: Blitzball,
	s_bocceball: Bocceball,
	s_bowling: Bowling,
	s_boxing: Boxing,
	s_broomball: Broomball,
	s_catchball: Catchball,
	s_cheer: Cheer,
	s_cornhole: Cornhole,
	s_corporateevents: CorporateEvents,
	s_cricket: Cricket,
	s_crossfit: Crossfit,
	s_curling: Curling,
	s_cycling: Cycling,
	s_dance: Dance,
	s_dodgeball: Dodgeball,
	s_fieldhockey: FieldHockey,
	's_figure-skating': FigureSkating,
	s_fitness: Fitness,
	s_football: Football,
	s_frisbee: Frisbee,
	s_futsal: Futsal,
	s_golf: Golf,
	s_gymnastics: Gymnastics,
	s_handball: Handball,
	s_hockey: Hockey,
	s_kickball: Kickball,
	s_kickboxing: Kickboxing,
	s_lacrosse: Lacrosse,
	s_martialarts: MartialArts,
	s_ninja_parkour: NinjaParkour,
	s_other: Other,
	s_outdoor: Outdoor,
	s_pickleball: Pickleball,
	s_pilatis: Pilatis,
	s_pingpong: Pingpong,
	s_raquetball: Raquetball,
	s_rollerderby: Rollerderby,
	s_rowing: Rowing,
	s_rugby: Rugby,
	s_running: Running,
	s_sailing: Sailing,
	s_skating: Skating,
	s_skeeball: Skeeball,
	s_skiing: Skiing,
	s_snowboarding: Snowboarding,
	s_soccer: Soccer,
	s_softball: Softball,
	s_spinning: Spinning,
	s_squash: Squash,
	s_sup: Sup,
	s_surfing: Surfing,
	s_swiming: Swiming,
	s_tennis: Tennis,
	s_throwingaxe: ThrowingAxe,
	s_triathlon: Triathlon,
	s_vollyball: Vollyball,
	s_wiffleball: Wiffleball,
	s_windsurfing: WindSurfing,
	s_yoga: Yoga,
};

/**
 * Legacy API / Icons enum keys that do not match canonical registry keys.
 * Mirrors icons_v2 mappings until activity data migration (BOND-18358).
 */
const sportIconLegacyAliases: Record<string, keyof typeof sportIconByCanonicalKey> = {
	s_gold: 's_golf',
	s_martialArts: 's_martialarts',
	s_runnning: 's_running',
	s_throwing_axe: 's_throwingaxe',
	s_figure_skating: 's_figure-skating',
	birthday: 's_birthday',
	corporateEvents: 's_corporateevents',
};

const normalizeSportIconKey = (icon: string): string =>
	icon.replace(/^s_/, '').toLowerCase().replace(/[-_]/g, '');

const sportIconByNormalizedKey = Object.entries(sportIconByCanonicalKey).reduce<
	Record<string, ComponentType<ClassNameProp>>
>((lookup, [key, component]) => {
	lookup[normalizeSportIconKey(key)] = component;
	return lookup;
}, {});

export const sportIconByKey: Record<string, ComponentType<ClassNameProp>> = {
	...sportIconByCanonicalKey,
	...Object.fromEntries(
		Object.entries(sportIconLegacyAliases).map(([legacyKey, canonicalKey]) => [
			legacyKey,
			sportIconByCanonicalKey[canonicalKey],
		]),
	),
};

/**
 * Resolves a sport icon component from API or UI sport.icon values.
 */
export const getSportIconComponent = (icon: string): ComponentType<ClassNameProp> | undefined =>
	sportIconByKey[icon] ?? sportIconByNormalizedKey[normalizeSportIconKey(icon)];
